export const setUrlParams = (params: Record<string, string>) => {
  const searchParams = new URLSearchParams(window.location.search);
  Object.entries(params).forEach(([key, value]) => {
    searchParams.set(key, value);
  });
  // URL을 직접 변경하여 이벤트 발생
  window.location.search = searchParams.toString();
};

export const deleteUrlParams = (keys: string[]) => {
  const searchParams = new URLSearchParams(window.location.search);
  keys.forEach(key => {
    searchParams.delete(key);
  });
  window.location.search = searchParams.toString();
};